<template>
  <div
    v-if="$store.getters.isLoggedIn"
    id="content"
    class="page">
    <!-- Drawer -->
    <v-navigation-drawer
      v-model="isDrawerOpen"
      width="250px"
      mobile-break-point="0"
      floating
      app>
      <div class="h-100 d-flex flex-column page-drawer">
        <div class="page-logo-container mx-auto my-5">
          <!-- DelMar Logo -->
          <router-link
            id="logo"
            to="/content">
            <img
              src="../assets/img/logo.png"
            />
          </router-link>
          <!-- / DelMar Logo -->
        </div>

        <div class="page-navigation-container d-flex flex-column flex-grow-1">
          <!-- Main Navigation -->
          <MainNavigation />
          <!-- / Main Navigation -->

          <!-- Content Navigation -->
          <ContentNavigation />
          <!-- / Content Navigation -->
        </div>

        <!-- User Account Menu -->
        <UserMenu class="mt-auto" />
        <!-- User Account Menu -->
      </div>
    </v-navigation-drawer>
    <!-- / Drawer -->

    <!-- Content Page Content -->
    <v-content class="h-100">
      <v-toolbar
        class="my-2 page-toolbar">
        <v-app-bar-nav-icon
          class="page-drawer-toggle"
          @click="isDrawerOpen = !isDrawerOpen">
        </v-app-bar-nav-icon>

        <v-toolbar-title
          class="pl-0">
          <h4 class="d-flex align-center">
            {{$store.state.user.projectName}}
          </h4>
        </v-toolbar-title>

        <v-spacer></v-spacer>

        <!-- Page Filter -->
        <div
          class="page-filter">
          <v-text-field
            prepend-inner-icon="mdi-magnify"
            clearable
            outlined
            filled
            hide-details
            v-model="contentFilter"
            placeholder="Filter by content text">
          </v-text-field>
        </div>
        <!-- / Page Filter -->
      </v-toolbar>

      <v-divider class="mx-5"></v-divider>

      <!-- Content List -->
      <ContentList :content-grouped="contentGrouped" />
      <!-- / Content List -->
    </v-content>
    <!-- / Content Page Content -->
  </div>
</template>

<script>
import _ from 'lodash';
import MainNavigation from '../components/MainNavigation.vue';
import ContentNavigation from '../components/ContentNavigation.vue';
import UserMenu from '../components/UserMenu.vue';
import ContentList from '../components/ContentList.vue';

export default {
  name: 'Content',
  components: {
    MainNavigation,
    ContentNavigation,
    UserMenu,
    ContentList,
  },
  data() {
    return {
      isDrawerOpen: true,
      contentFilter: '',
    };
  },
  computed: {
    contentGrouped() {
      const contentFilter = (content) => {
        const section = content.contentId.split('.')[0].toLowerCase();
        let contentTextContent = document.createElement('span');

        contentTextContent.innerHTML = content.content;
        contentTextContent = contentTextContent.textContent || contentTextContent.innerText;

        const sectionTypeFilter = this.$route.params.section === 'all'
          || section === this.$route.params.section
          || content.type.toLowerCase().includes(this.$route.params.section);

        const contentFilterFilter = !this.contentFilter
          || (content.type !== 'image'
            && contentTextContent.toLowerCase().includes(this.contentFilter.toLowerCase()));

        return sectionTypeFilter && contentFilterFilter;
      };

      return _(this.$store.state.content)
        .filter(contentFilter)
        .groupBy((content) => content.contentId.split('.')[0])
        .value();
    },
  },
};
</script>

<style lang="scss"></style>
